



























































































import { Vue, Prop, Component } from "vue-property-decorator";
import { PracticePass as IPracticePass } from "@/api/models/practice-pass";
import { practiceStatusFormatter } from "@/plugins/statuses";
import { isRoot } from "@/plugins/roles";
import TextField from "@/components/form/CustomPage/textField.vue";
@Component({
  components: { TextField }
})
export default class PracticePassResult extends Vue {
  @Prop() practicePass?: IPracticePass;

  formattedBody() {
    let a = this.practicePass?.listener?.course?.practice?.body;
    a = a?.substring(3, a.length - 4);
    return a;
  }

  formattedPracticePassStatus(status: string) {
    return practiceStatusFormatter(status);
  }

  get root() {
    return isRoot();
  }

  get currentCompanyId() {
    return this.$store.getters.selectedCompany.id;
  }

  get isGranted() {
    return (
      this.currentCompanyId ===
        this.practicePass?.listener?.course?.company?.id || this.root
    );
  }
}
